var map = {
	"./cadastro-automoveis.jpg": "3994",
	"./cadastro-checklist.jpg": "99e1",
	"./cadastro-checklist2.jpg": "b18f",
	"./cadastro-clientes.jpg": "778d",
	"./cadastro-clientes2.jpg": "0506",
	"./cadastro-pecas.jpg": "345e",
	"./cadastro-servicos.jpg": "4e19",
	"./cadastro-usuarios-oficina.jpg": "39cc",
	"./cadastro-website.png": "fdef",
	"./clientes.jpeg": "bbc0",
	"./indicadores.jpg": "7179",
	"./painel-ferramenta.jpg": "bbd5",
	"./sala-espera.jpeg": "a44e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "754a";